import { Button, Skeleton } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/PopoverMenu'
import { handleResult } from 'modules/core/lib/handleMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import usePromoteMember from 'modules/teams/components/Detail/hooks/usePromoteMember'
import app from 'modules/core/store/models/app'

import useRemoveMember from 'modules/teams/components/Detail/hooks/useRemoveMember'

interface Props {
  membershipId: string
  teamId: string
  employeeId: string
  readonly?: boolean
}

const Settings = ({ membershipId, teamId, employeeId, readonly }: Props) => {
  const { promoteMember, loading: promoteLoading } = usePromoteMember()
  const { removeMember, loading: removeLoading } = useRemoveMember()

  const onClickMemberPromote = async () => {
    track(trackingEvents.teams.promoteMemberStart, {
      team_id: teamId,
      employee_id: employeeId,
    })
    const result = await promoteMember({ id: membershipId })
    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      track(trackingEvents.teams.promoteMemberSubmit, {
        team_id: teamId,
        employee_id: employeeId,
      })
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.save_error'),
      })
    }
  }

  const onClickMemberRemove = async () => {
    track(trackingEvents.teams.removeMemberStart, {
      team_id: teamId,
      employee_id: employeeId,
      is_lead: false,
    })
    const result = await removeMember({ id: membershipId })
    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      track(trackingEvents.teams.removeMemberSubmit, {
        team_id: teamId,
        employee_id: employeeId,
        is_lead: false,
      })
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.save_error'),
      })
    }
  }

  const renderSettings = () => {
    if (readonly) return null

    return (
      <Popover type="list">
        <Popover.Trigger>
          {promoteLoading || removeLoading ? (
            <Skeleton width="s32" height="s32" />
          ) : (
            <Button.Decorative type="secondary" iconName="ellipsis" />
          )}
        </Popover.Trigger>
        <Popover.Content side="bottom" align="center">
          <Popover.TouchableOption
            title={i18n.t('teams.promote_to_leader')}
            onClick={onClickMemberPromote}
          />
          <Popover.TouchableOption
            danger
            title={i18n.t('teams.remove_from_team')}
            onClick={onClickMemberRemove}
          />
        </Popover.Content>
      </Popover>
    )
  }

  return renderSettings()
}

export default Settings
